import { useMemo } from 'react';

import { useQuery } from '@tanstack/react-query';

import UsersService from '~/services/UsersService';

import { usersQueryKeys } from './usersQueryKeys';

type Params = {
  userIds: string[];
  brand: string;
  enabled?: boolean;
};

export function useGetUsersSummaryByIds({ userIds, brand, enabled = true }: Params) {
  const normalizedUserIds = useMemo(() => {
    const ids = userIds.filter(Boolean);
    return Array.from(new Set(ids)).sort();
  }, [userIds]);

  return useQuery({
    queryKey: usersQueryKeys.summariesByIds(brand, normalizedUserIds),
    queryFn: async () => {
      if (!normalizedUserIds.length) {
        return new Map();
      }
      return await UsersService.getUsersSummaryByIds(normalizedUserIds, brand);
    },
    enabled: enabled && normalizedUserIds.length > 0 && Boolean(brand),
  });
}
